import { ScopeUsageResponse, ScopeUsageType } from '@ydistri/api-sdk';

type FormattableScopeUsage = Pick<ScopeUsageResponse, 'aso' | 'occurrenceId'> & { type: string };

export const formatScopeUsage = (usage: FormattableScopeUsage): string => {
  const usageType = String(usage.type);
  const isAsoUsage =
    usageType === ScopeUsageType.AsoSource || usageType === ScopeUsageType.AsoTarget;

  if (!isAsoUsage || !usage.aso) {
    return `${usageType} usage #${usage.occurrenceId}`;
  }

  const role = usageType === ScopeUsageType.AsoSource ? 'Source' : 'Target';
  const { request, scenario } = usage.aso;
  return `ASO request #${request.id} “${request.name}” → scenario #${scenario.id} “${scenario.name}” — ${role}`;
};
